const customModalOptionsStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 110,
    border: '3px solid white',
    borderRadius: '10px',
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: 'white',
  },
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.5)',
  }
};

export { customModalOptionsStyles };